if (
  (window.regWallContainer = document.querySelector(
    ".registration-wall--container",
  ))
) {
  let source = regWallContainer.dataset.source

  Activity.track("registration-wall", "show", source)

  regWallContainer
    .querySelector(".registration-wall--unlock")
    .addEventListener("click", function () {
      document.body.classList.remove("show-registration-wall")
      RailsRequest.post(regWallContainer.dataset.suppressUrl)
      regWallContainer.remove()
      Cookies.set("reg_wall_dnd", "true", {
        expires: 7,
      })
      Activity.track("registration-wall", "dismiss", source)

      document.dispatchEvent(new Event("regwall:unlock"))
    })
}
